

import React, { useState } from 'react';
import logo from '../assets/biokare-logo.jpeg';



function Navbar() {
	const [menuOpen, setMenuOpen] = useState(false);
	const handleNavClick = (e, sectionId) => {
		e.preventDefault();
		window.history.replaceState(null, '', `/${sectionId}`);
		const section = document.getElementById(sectionId);
		if (section) {
			section.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
		setMenuOpen(false); // close menu after click
	};

			return (
				<nav className="navbar">
					<div className="logo-title">
						<img src={logo} alt="Biokare Logo" className="navbar-logo" />
						<span className="navbar-title">Biokare</span>
					</div>
					{/* Hamburger and overlay only on mobile */}
					<div className="navbar-mobile">
						<button
							className="navbar-toggle"
							aria-label="Open navigation menu"
							onClick={() => setMenuOpen(true)}
						>
							<span className="navbar-hamburger">&#9776;</span>
						</button>
						{menuOpen && (
							<div className="navbar-overlay">
								<button
									className="navbar-close"
									aria-label="Close navigation menu"
									onClick={() => setMenuOpen(false)}
								>
									<span className="navbar-close-icon">&times;</span>
								</button>
								<ul className="nav-links open">
									<li><a href="/home" onClick={e => handleNavClick(e, 'home')}>Home</a></li>
									<li><a href="/treatments" onClick={e => handleNavClick(e, 'treatments')}>Our Services</a></li>
									<li><a href="/about" onClick={e => handleNavClick(e, 'about')}>About Us</a></li>
									<li><a href="/doctor" onClick={e => handleNavClick(e, 'doctor')}>Meet the Dentist</a></li>
									<li><a href="/gallery" onClick={e => handleNavClick(e, 'gallery')}>Smile Gallery</a></li>
									<li><a href="/appointment" onClick={e => handleNavClick(e, 'appointment')}>Book Appointment</a></li>
									<li><a href="/contact" onClick={e => handleNavClick(e, 'contact')}>Contact Us</a></li>
								</ul>
							</div>
						)}
					</div>
					{/* Desktop nav links always visible */}
					<ul className="nav-links desktop">
						<li><a href="/home" onClick={e => handleNavClick(e, 'home')}>Home</a></li>
						<li><a href="/treatments" onClick={e => handleNavClick(e, 'treatments')}>Our Services</a></li>
						<li><a href="/about" onClick={e => handleNavClick(e, 'about')}>About Us</a></li>
						<li><a href="/doctor" onClick={e => handleNavClick(e, 'doctor')}>Meet the Dentist</a></li>
						<li><a href="/gallery" onClick={e => handleNavClick(e, 'gallery')}>Smile Gallery</a></li>
						<li><a href="/appointment" onClick={e => handleNavClick(e, 'appointment')}>Book Appointment</a></li>
						<li><a href="/contact" onClick={e => handleNavClick(e, 'contact')}>Contact Us</a></li>
					</ul>
				</nav>
			);
}


export default Navbar;